/*
 * @Author: liyifan
 * @Date: 2024-06-17 18:33:22
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-04-23 16:08:19
 */
import './index.less'
import { CountDownBanner } from './sections/index-countdown-banner'
import { VideoBanner } from './sections/index-video-banner'
import { ProductsSwiper } from './sections/index-new-product'
import { SceneEducation } from './sections/index-scene-education'
import { AwardsSwiper } from './sections/index-awards'
import { StoriesSwiper } from './sections/index-stories'
import { BlogsSwiper } from './sections/index-blogs'
import { IndexNewGAEvent } from "./sections/index-new-ga"
import { RegularBanner } from "./sections/index-regular-banner"

$(document).ready(function() {
    new RegularBanner(document.querySelector('.index-regular-banner .swiper-container'))
    $('.index-function-banner').each(function(){
        const clas = $(this).data('name')
        if (clas) {
            const type = $(`.${clas}`).data('type')
            type === 'countdown' &&  new CountDownBanner({el: $(`.${clas}`), clas});
            type === 'video' && new VideoBanner({el:  $(`.${clas}`), clas});

        }
    })

    $('.index-new-products').each(function(){
        const clas = $(this).data('name')
        clas && new ProductsSwiper({el: $(`.${clas}`), clas})
    })
    new SceneEducation()
    new AwardsSwiper()
    new StoriesSwiper()
    new BlogsSwiper()

    IndexNewGAEvent()

   // 渐变出现
   const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
            // 元素进入视窗,触发动画
            entry.target.classList.add('jky-slideup-animate');
            }
        });
    });

    // 开始观察目标元素
    const slideups = document.querySelectorAll('.jky-slideup')
    if (slideups && slideups.length) {
        slideups.forEach(item => {
            observer.observe(item);
        })
    }
})